import React, { memo, useEffect, useState } from 'react'
import Header from '../../components/atoms/Header'
import Text from '../../components/atoms/Text'
import AddAddressDetails from './AddAddressDetails'
import AddUserDetails from './AddUserDetails'
import DiagnosticSlotsDetails from './DiagnosticSlotDetails'
import MobileLayout from '../../components/MobileLayout'
import { useLocation, useNavigate } from 'react-router-dom'

const sections = [
  { comp: AddUserDetails },
  { comp: AddAddressDetails },
  { comp: DiagnosticSlotsDetails },
]

const PurchaseDiagnosticPage = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const query = new URLSearchParams(location.search)
  const step = Number(query.get('step'))
  const [currentStep, setCurrentStep] = useState(step ?? 0)

  const onBackPress = () => {
    if (currentStep > 0) {
      setCurrentStep(() => currentStep - 1)
      return
    } else {
      navigate(-1)
    }
  }

  const onProceed = (paymentStatus) => {
    if (currentStep < 2 && !paymentStatus) {
      setCurrentStep(() => currentStep + 1)
    } else {
    }
  }

  const CurrentActiveComponent = sections[currentStep].comp

  return (
    <MobileLayout>
      <div>
        <Header
          title="Back"
          onPressLeftIcon={onBackPress}
          showProgressBar
          progress={currentStep + 1}
          totalProgress={3}
        />
        <div className="pt-2 lg:max-w-2xl lg:mx-auto">
          <CurrentActiveComponent onProceed={onProceed} />
        </div>
      </div>
    </MobileLayout>
  )
}

export default memo(PurchaseDiagnosticPage)
